var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudSolutions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.01306 72.16H30.3331V87.15H7.01306V72.16Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0031 72.16H58.6631V87.15H37.0031V72.16Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.983 72.16H88.643V87.15H66.983V72.16Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0131 92.15H27.0031",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.673 87.15V92.15",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.333 92.15H55.323",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.663 87.15V92.15",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.323 92.15H85.313",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.983 87.15V92.15",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.673 67.16V52.16",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.663 67.16V48.83",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6531 67.16V53.83",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0031 55.54H45.3331",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.993 55.54H65.323",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.673 48.83V43.83",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M28.673 40.4999V37.1699",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M48.663 43.84V40.5",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.663 37.1699V32.1699",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6531 50.5V45.5",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M48.663 28.84V25.51",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 8
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M71.843 55.45H77.673C84.873 55.45 90.663 49.47 90.663 42.05C90.663 34.63 84.873 28.65 77.673 28.65C76.363 28.65 74.963 28.84 73.753 29.32C73.933 28.45 74.033 27.58 74.033 26.81C74.033 19.38 68.233 13.41 61.043 13.41C57.953 13.41 54.873 14.57 52.533 16.69C49.923 8.96998 42.913 3.84998 35.063 3.84998C24.783 3.84998 16.463 12.43 16.463 23.04C16.463 24.97 16.743 26.99 17.303 28.83C10.573 29.41 5.34302 35.2 5.34302 42.14C5.34302 49.57 11.133 55.54 18.333 55.54H23.823",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.533 16.58C53.003 18.03 53.373 19.47 53.473 21.02",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M73.773 29.22C73.493 30.76 72.933 32.21 72.183 33.56",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M17.303 28.83C18.893 28.73 20.573 28.93 22.163 29.41",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSolutions);
export default __webpack_public_path__ + "static/media/cloudSolutions.c8faa5ee350f416dc9f2d3db73e82b23.svg";
export { ForwardRef as ReactComponent };